import __ from "web/Layout/Translations";

import formatDate from "web/utils/data/parser/dateAndTime/formatDate";
import getDateTime from "web/utils/data/parser/dateAndTime/getDateTime";
import { ITourismInternationalValues } from "web/utils/page/product/universal/groupProducts";

export default (data: ITourismInternationalValues, isMobile = false) => {
  if (data && Object.keys(data).length) {
    const consultant = data.consultant_email
      ? [
          {
            name: __("Konsultant biura podróży"),
            value: data.consultant_email,
            dataT1: "consultant_email_label",
          },
        ]
      : [];
    const date =
      data.date_from && data.date_to
        ? [
            {
              name: __("Termin wyjazdu"),
              value: (
                <span>
                  <time dateTime={getDateTime(data.date_from)}>
                    {formatDate(data.date_from)}
                  </time>{" "}
                  -{" "}
                  <time dateTime={getDateTime(data.date_to)}>
                    {formatDate(data.date_to)}
                  </time>
                </span>
              ),
              dataT1: "date",
              dataT2: `${getDateTime(data.date_from)} - ${getDateTime(
                data.date_to
              )}`,
            },
          ]
        : [];
    const phone = data.phone
      ? [
          {
            name: __("Numer telefonu"),
            value: data.phone,
            dataT1: "phone",
          },
        ]
      : [];
    const email = data.email
      ? [
          {
            name: __("E-mail"),
            value: data.email,
            dataT1: "email",
          },
        ]
      : [];

    return isMobile
      ? [...consultant, ...date]
      : [...consultant, ...date, ...phone, ...email];
  }

  return [];
};
